// Audio kernel module: Panner
// Manages audiospatialisation

import * as audio from '../audio.js';

export {
    createPanner,
    positionListener, orientListener
}

function createPanner (options = {}) {    
    const panner = audio.context.createPanner();
    
    panner.panningModel = 'HRTF';
    panner.distanceModel = "inverse";
    panner.refDistance = 20;
    panner.maxDistance = 2000;
    panner.rolloffFactor = 1;
    panner.coneInnerAngle = 360;
    panner.coneOuterAngle = 0;
    panner.coneOuterGain = 0;
    
    if (panner.orientationX) {
        panner.orientationX.setValueAtTime(0, audio.context.currentTime);
        panner.orientationY.setValueAtTime(0, audio.context.currentTime);
        panner.orientationZ.setValueAtTime(-1, audio.context.currentTime);
    } else {
        panner.setOrientation(0, 0, -1);
    }

    panner.positionPanner = function (x, y, z) {
        if (panner.positionX) {
            panner.positionX.setValueAtTime(x, audio.context.currentTime);
            panner.positionY.setValueAtTime(y, audio.context.currentTime);
            panner.positionZ.setValueAtTime(z, audio.context.currentTime);
        } else {
            panner.setPosition(x, y, z);
        }
    }

    panner.connect(options.destination || audio.context.destination);

    return panner;
}

function positionListener(x, y, z) {
    const listener = audio.context.listener;

    if (listener.positionX) {
        listener.positionX.setValueAtTime(x, audio.context.currentTime);
        listener.positionY.setValueAtTime(y, audio.context.currentTime);
        listener.positionZ.setValueAtTime(z, audio.context.currentTime);
    } else {
        listener.setPosition(x, y, z);
    }
}

function orientListener(fx, fy, fz = -1, ux = 0, uy = 1, uz = 0) {
    const listener = audio.context.listener;

    if (listener.forwardX) {
        listener.forwardX.setValueAtTime(fx, audio.context.currentTime);
        listener.forwardY.setValueAtTime(fy, audio.context.currentTime);
        listener.forwardZ.setValueAtTime(fz, audio.context.currentTime);
        listener.upX.setValueAtTime(ux, audio.context.currentTime);
        listener.upY.setValueAtTime(uy, audio.context.currentTime);
        listener.upZ.setValueAtTime(uz, audio.context.currentTime);
    } else {
        listener.setOrientation(fx, fy, fz, ux, uy, uz);
    }
}